import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getCurrentEnvironment, getEnvironmentConfig } from '@/utils/environment';

const environment = getCurrentEnvironment();
const envConfig = getEnvironmentConfig();

const firebaseConfig = {
    apiKey: import.meta.env.VITE_REACT_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_REACT_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_REACT_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_REACT_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_REACT_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_REACT_FIREBASE_APP_ID
};

// Validation
if (!firebaseConfig.projectId) {
    throw new Error(`Firebase project ID is required. Please check your .env.${environment} file.`);
}

// Log environment info (always log to debug environment issues)
console.log('🔧 Firebase Environment Configuration:', {
    detectedEnvironment: environment,
    viteMode: import.meta.env.MODE,
    nodeEnv: import.meta.env.NODE_ENV,
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain,
    allEnvVars: {
        VITE_REACT_FIREBASE_PROJECT_ID: import.meta.env.VITE_REACT_FIREBASE_PROJECT_ID,
        VITE_REACT_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_REACT_FIREBASE_AUTH_DOMAIN,
    }
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Log Firebase connection info - Visible and clear
const projectName = firebaseConfig.projectId === 'radar-projetos' ? 'PRODUCTION' : 'DEVELOPMENT';
console.log(`
🔥 Firebase Connected: ${projectName}
   Project ID: ${firebaseConfig.projectId}
   Environment: ${environment}
`);

// Initialize services
export const db = getFirestore(app);
export const storage = getStorage(app);

// Export app and environment info
export { app, environment, envConfig }; 